import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { InputWhite } from "@UI/New/InputWhite";
import s from './index.module.css';

export const AudienceNumber = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    
    return (
        <InputWhite 
            value={state.audienceNumber}
            placeholder='Аудитория занятия'
            onChange={value => setFieldInState({field: 'audienceNumber', value})}
            className={s.input}
        />
    )
}